import React from 'react';
import './Footer.css';

const Footer = () => (
  <footer className="footer navbar-light bg-light mt-0 pt-0">
    <div className="container d-flex justify-content-center py-0">
      <a
        href="https://tifin.com/terms-conditions/"
        target="_blank"
        rel="noopener noreferrer"
        className="nav-link px-3"
      >
        Terms of Use
      </a>
      <a
        href="https://tifin.com/privacy-policy/"
        target="_blank"
        rel="noopener noreferrer"
        className="nav-link px-3"
      >
        Privacy Policy
      </a>
      <a
        href="https://magnificommunities.com/supplemental-terms/"
        target="_blank"
        rel="noopener noreferrer"
        className="nav-link px-3"
      >
        Supplemental Terms
      </a>
    </div>
  </footer>
);

export default Footer;
